import { register } from "@rill/loader";

register(
  {
    name: "tourConfig",
    meta: ["token"],
    ttl: "30 seconds",
  },
  async ({ api }, { token }) => {
    if (!token || !/^[0-9a-f]{64}$/.test(String(token))) {
      return { config: null, error: "invalid-token" };
    }
    try {
      const res = await api(`public/tour/${encodeURIComponent(token)}`);
      return { config: await res.json(), error: null };
    } catch (e) {
      const code = typeof e?.code === "number" ? e.code : null;
      if (code !== 410) {
        console.error("[book-tour] config load failed:", code, e?.message);
      }
      return { config: null, error: code === 410 ? "gone" : "unavailable" };
    }
  }
);
